import { useEffect, useRef } from 'react'

export const TURNSTILE_SITE_KEY = (import.meta as any).env?.VITE_TURNSTILE_SITE_KEY ?? ''

interface TurnstileProps {
  onVerify: (token: string) => void
  theme?: 'light' | 'dark' | 'auto'
  className?: string
}

export function Turnstile({ onVerify, theme = 'light', className = 'mt-4' }: TurnstileProps) {
  const containerRef = useRef<HTMLDivElement>(null)
  const widgetId = useRef<string | null>(null)

  useEffect(() => {
    if (!TURNSTILE_SITE_KEY) return

    const win = window as any

    const doRender = () => {
      if (!containerRef.current || widgetId.current !== null) return
      widgetId.current = win.turnstile.render(containerRef.current, {
        sitekey: TURNSTILE_SITE_KEY,
        callback: onVerify,
        'expired-callback': () => onVerify(''),
        theme,
      })
    }

    if (win.turnstile) {
      doRender()
    } else {
      window.addEventListener('turnstile:ready', doRender, { once: true })
    }

    return () => {
      window.removeEventListener('turnstile:ready', doRender)
      if (widgetId.current !== null && win.turnstile) {
        win.turnstile.remove(widgetId.current)
        widgetId.current = null
      }
    }
  }, [onVerify, theme])

  if (!TURNSTILE_SITE_KEY) return null

  return <div ref={containerRef} className={className} />
}
